import { defineComponent as _defineComponent } from 'vue'
import moment from 'moment';
import { computed, onMounted, ref, unref, watch } from 'vue';

import BootstrapDatepicker from './bootstrap-datepicker.vue';
import BootstrapSelect2 from './bootstrap-select2.vue';
import type { FixedPeriodTableType } from './period-filter-control';
import {
    DefaultFixedPeriodTable, NullFixedPeriod, SelectedPeriod,
    TuttiFixedPeriod,
} from './period-filter-control';


export default /*#__PURE__*/_defineComponent({
  __name: 'period-filter-box',
  props: {
    periodTable: null,
    modelValue: null,
    selectedPeriod: null
  },
  emits: ["update:modelValue", "update:selectedPeriod"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'update:modelValue', value: SelectedPeriod): void;
    (event: 'update:selectedPeriod', value: string | undefined): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    periodTable?: FixedPeriodTableType;
    modelValue?: SelectedPeriod;
    selectedPeriod?: string;
}


//eslint-disable-next-line no-spaced-func


const selectedPickerRef = ref(pickerFromValue(props.modelValue, props.selectedPeriod));
const selectedPeriodRef = ref(periodFromValue(props.selectedPeriod));
const periodTableRef = computed(() => props.periodTable ?? DefaultFixedPeriodTable);

function pickerFromValue(value: SelectedPeriod | undefined, period: string | undefined) {
    if(value) {
        return new SelectedPeriod(value).toMoment();
    }
    return SelectedPeriod.fromFixedPeriod2(undefined, periodFromValue(period), -1);
}

function periodFromValue(period: string | undefined) {
    return (!period || (period == TuttiFixedPeriod)) ? NullFixedPeriod : period;
}

function emitUpdatePicker() {
    const _selectedValue = SelectedPeriod.fromMoment(unref(selectedPickerRef));
    if(!SelectedPeriod.compare(props.modelValue, _selectedValue)) {
        emit('update:modelValue', _selectedValue);
    }
}

function emitUpdatePeriod() {
    const _selectedPeriod = unref(selectedPeriodRef);
    if(_selectedPeriod == props.selectedPeriod) {
        return;
    }
    emit('update:selectedPeriod', _selectedPeriod);
}

function pickerChangedExternally() {
    const from = moment(unref(selectedPickerRef).from);
    const to = moment(unref(selectedPickerRef).to);
    const diff = to.diff(from, 'day');
    for(const period of Object.keys(unref(periodTableRef))) {
        if(diff == Number(period)) {
            selectedPeriodRef.value = period;
            emitUpdatePeriod();
            break;
        }
    }
    emitUpdatePicker();
}

function periodChanged() {
    syncPickers(unref(selectedPickerRef).to, -1);
    emitUpdatePeriod();
}

function syncPickers(base: Date, sign: number) {
    if(unref(selectedPeriodRef) !== NullFixedPeriod) {
        selectedPickerRef.value = SelectedPeriod.fromFixedPeriod2(base, unref(selectedPeriodRef), sign);
    }
    emitUpdatePicker();
}

function movePickers(sign: number) {
    let from = moment(unref(selectedPickerRef).from);
    let to = moment(unref(selectedPickerRef).to);
    const diff = to.diff(from, 'day');
    if(sign > 0) {
        from = to;
        to = moment(from).add(diff, 'day');
    } else {
        to = from;
        from = moment(to).add(-diff, 'day');
    }
    selectedPickerRef.value = SelectedPeriod.normalizeMoment(from, to);
    emitUpdatePicker();
}

watch(() => [props.modelValue, props.selectedPeriod] as const, (val, old) => {
    selectedPickerRef.value = pickerFromValue(props.modelValue, props.selectedPeriod);
    selectedPeriodRef.value = periodFromValue(props.selectedPeriod);
    if(val[0] !== old[0]) {
        if(val[1] === old[1]) {
            pickerChangedExternally();
        } else {
            emitUpdatePicker();
        }
    }
    if(val[1] !== old[1]) {
        periodChanged();
    }
});

onMounted(() => {
    emitUpdatePicker();
    emitUpdatePeriod();
});

return { __sfc: true,props, emit, selectedPickerRef, selectedPeriodRef, periodTableRef, pickerFromValue, periodFromValue, emitUpdatePicker, emitUpdatePeriod, pickerChangedExternally, periodChanged, syncPickers, movePickers, BootstrapDatepicker, BootstrapSelect2, NullFixedPeriod }
}

})